import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest } from "../services/index";

const API_URL = "/api/gracePeriods"; // Matches your backend route in server.ts

// Fetch all Grace Periods
export const fetchGracePeriods = createAsyncThunk("gracePeriods/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data);
  return response.data;
});

// Fetch Grace Periods by Employee ID
export const fetchGracePeriodByEmployee = createAsyncThunk(
  "gracePeriods/fetchByEmployee",
  async (employeeId) => {
    const response = await hrmsGetRequest(`${API_URL}/${employeeId}`);
    return response.data;
  }
);

// Add Grace Period
export const addGracePeriod = createAsyncThunk("gracePeriods/add", async (gracePeriodData) => {
  const response = await hrmsPostRequest(API_URL, gracePeriodData);
  return response.data;
});

const gracePeriodSlice = createSlice({
  name: "gracePeriods",
  initialState: {
    gracePeriods: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGracePeriods.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchGracePeriods.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.gracePeriods = action.payload;
      })
      .addCase(fetchGracePeriods.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchGracePeriodByEmployee.fulfilled, (state, action) => {
        state.gracePeriods = action.payload;
      })
      .addCase(addGracePeriod.fulfilled, (state, action) => {
        state.gracePeriods.push(action.payload);
      });
  },
});

export default gracePeriodSlice.reducer;